import { getApi, postApi } from './common/apis';

export default class PartnerRankingService {
    /**
     * Get vendor ranking for a vendor within a subnetwork
     * Returns { subnetwork_id, vendor_id, rank, rank_boost }
     */
    async getVendorRanking(subnetworkId, vendorId) {
        const sid = encodeURIComponent(subnetworkId || '');
        const vid = encodeURIComponent(vendorId || '');
        return await getApi(`v1/vendor-ranking?subnetwork_id=${sid}&vendor_id=${vid}`);
    }

    /**
     * Upsert vendor ranking for a vendor within a subnetwork
     * Body: { subnetwork_id, vendor_id, rank, rank_boost }
     */
    async upsertVendorRanking({ subnetwork_id, vendor_id, rank = 0, rank_boost = 0 }) {
        return await postApi(`v1/vendor-ranking`, {
            subnetwork_id,
            vendor_id,
            rank,
            rank_boost,
        });
    }
    
    /**
     * Get partner list with ranking data
     * @param {string} subnetworkId - The subnetwork ID
     * @returns {Promise<Object>} - The API response with partner list
     */
    async getPartnerList(subnetworkId = process.env.VUE_APP_DEFAULT_SUBNETWORK_ID) {
        try {
            const response = await getApi(`v1/partner-list-rank?subnetwork_id=${subnetworkId}`);
            return response;
        } catch (error) {
            console.error('Error fetching partner list:', error);
            throw error;
        }
    }

    /**
     * Get presigned URL for uploading vendor ranking Excel
     */
    async getPresignedUrl(fileName, contentType) {
        const encodedName = encodeURIComponent(fileName);
        const encodedType = encodeURIComponent(contentType);
        return await getApi(`v1/upload-url?vendor-ranking=true&file_name=${encodedName}&content_type=${encodedType}`);
    }

    /**
     * Upload file to S3 via presigned URL
     */
    async uploadToS3(uploadURL, file) {
        const res = await fetch(uploadURL, {
            method: 'PUT',
            headers: {
                'Content-Type': file.type || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            body: file
        });
        if (!res.ok) {
            throw new Error('Failed to upload file to storage');
        }
        return true;
    }

    /**
     * Notify backend about uploaded ranking file
     */
    async notifyUpload(key, subnetworkId) {
        return await postApi(`v1/vendor-ranking/upload`, {
            key,
            subnetwork_id: subnetworkId
        });
    }
}

